import { useEffect, useState } from 'react';
import { RoutingVariantType } from 'src/components/organisms';
import { GroupType, Maybe } from 'src/graphql';
import { FormState } from 'src/types';

interface Parameters {
  destinationGroup?: Maybe<string>;
  disabled: boolean;
  groups: GroupType[];
  variant: RoutingVariantType;
}

export const useRoutingGroup = ({
  destinationGroup,
  disabled,
  groups,
  variant,
}: Parameters) => {
  const [groupDropdownState, setGroupDropdownState] = useState(
    !disabled ? FormState.DISABLED : FormState.DEFAULT,
  );
  const selectedGroup = destinationGroup
    ? groups.find((group) => group.id === destinationGroup)
    : undefined;

  const activeCount =
    variant === 'coi'
      ? selectedGroup?.ActiveCoiReviewerCount
      : selectedGroup?.ActiveCMCount;

  useEffect(() => {
    if (!disabled) {
      setGroupDropdownState(activeCount ? FormState.DISABLED : FormState.ERROR);
    } else if (selectedGroup) {
      setGroupDropdownState(activeCount ? FormState.DEFAULT : FormState.ERROR);
    } else {
      setGroupDropdownState(FormState.DEFAULT);
    }
  }, [selectedGroup, groups, disabled, activeCount]);

  return {
    groupDropdownState,
    selectedGroup,
  };
};
